<template>
  <v-app>
<!--    :class="{'app-bar-class' : !$vuetify.breakpoint.smAndDown}"-->
    <v-app-bar
      app
      :bottom="$vuetify.breakpoint.smAndDown"
      :hide-on-scroll="!$vuetify.breakpoint.smAndDown"
    >
      <v-toolbar-title
        @click="$router.push({name: 'Home'})"
        style="cursor: pointer"
        v-if="!$vuetify.breakpoint.smAndDown"
      >
        <v-icon>
          mdi-home-circle-outline
        </v-icon>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      color="rgba(0, 0, 0, 0.87)"
      right
      :width="$vuetify.breakpoint.smAndDown ? '85wv' : '45vw'"
    >
      <Menu @closeDrawer="closeDrawer"/>
    </v-navigation-drawer>

    <v-container fluid class="pa-0">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </v-container>
    <Footer :class="{'margin-footer' : $vuetify.breakpoint.smAndDown}"/>
  </v-app>
</template>

<script>
import Menu from "./components/Menu";
import Footer from "@/components/Footer";

export default {
  name: 'App',
  components: {
    Footer,
    Menu,
  },
  data() {
    return {
      drawer: false,
    }
  },
  methods: {
    closeDrawer() {
      this.drawer = false;
    },
  }
}

</script>
<!--todo убрать лишние стили-->

<style>
.soft-grey {
  background-color: #eeeeee;
}

.section-height {
  min-height: 100vh;
}

.max-width {
  max-width: 1000px;
}

/* отступ для меню*/
.margin-footer {
  margin-bottom: 55px;
}

.app-bar-class {
  opacity: 20%!important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}


/*стили для timeline from home.vue*/

/*оставить один вариант!!!*/

/*carusel right*/

.v-carousel--hide-delimiter-background .v-carousel__controls {
  background: transparent;
  right: calc(10% - 8px) !important;
}

.v-carousel__controls {
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  flex-direction: column !important;
  height: 100% !important;
  justify-content: center;
  list-style-type: none;
  position: absolute;
  width: 50px !important;
  /* z-index: 1; */
}

.v-carousel--hide-delimiter-background .v-carousel__controls:before {
  bottom: 0;
  content: "";
  height: 100%;
  position: absolute;
  top: 0;
  width: 0.5px;
  left: calc(45% - 1px);
  background: white;
  opacity: 0.64;
}

/*carusel left*/
.v-carousel--hide-delimiter-background .v-carousel__controls {
  background: transparent;
  left: calc(10% - 8px) !important;
}

.v-carousel__controls {
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  flex-direction: column !important;
  height: 100% !important;
  justify-content: center;
  list-style-type: none;
  position: absolute;
  width: 50px !important;
}

.v-carousel--hide-delimiter-background .v-carousel__controls:before {
  bottom: 0;
  content: "";
  height: 100%;
  position: absolute;
  top: 0;
  width: 0.5px;
  right: calc(45% - 1px);
  background: white;
  opacity: 0.64;
}


/*стили для timeline from home.vue закончиличь*/


</style>
